const BOOKING_COM_TOKENS = ['booking.com', 'bookingcom', 'booking'];
const GOMMT_TOKENS = ['gommt', 'go-mmt', 'go mmt', 'makemytrip', 'make my trip', 'mmt', 'goibibo'];

export function resolveNoShowOtaPartner(channelName) {
  const raw = String(channelName || '').trim().toLowerCase();
  if (!raw) return '';
  const compact = raw.replace(/[\s._-]+/g, '');
  if (GOMMT_TOKENS.some((token) => raw.includes(token) || compact.includes(token.replace(/[\s._-]+/g, '')))) {
    return 'gommt';
  }
  if (BOOKING_COM_TOKENS.some((token) => raw.includes(token) || compact.includes(token.replace(/[\s._-]+/g, '')))) {
    return 'booking.com';
  }
  return '';
}

export function getNoShowOtaPartnerLabel(partner) {
  if (partner === 'gommt') return 'GoMMT';
  if (partner === 'booking.com') return 'Booking.com';
  return partner || 'OTA';
}

const HTTP_STATUS_LABELS = {
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  408: 'Request Timeout',
  409: 'Conflict',
  422: 'Unprocessable Entity',
  429: 'Too Many Requests',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
};

const GENERIC_HTTP_DETAILS = new Set([
  'not found',
  'internal server error',
  'error',
  'unknown error',
  'bad request',
]);

export function formatNoShowOtaMessage(message) {
  const text = String(message || '').trim();
  if (!text) return '';
  const looksLikeHttp = /aiosell api error/i.test(text)
    || text.includes('://')
    || /\bStatus:\s*\d{3}\b/i.test(text)
    || /\bHTTP\s+\d{3}\b/i.test(text);
  if (!looksLikeHttp) return text;
  const detailMatch = text.match(/HTTP\s+\d{3}\s+[^:]+:\s+(.+)$/i);
  if (detailMatch) {
    const detail = detailMatch[1].trim().replace(/\.$/, '');
    if (detail && !detail.includes('://') && !GENERIC_HTTP_DETAILS.has(detail.toLowerCase())) {
      return detail;
    }
  }
  const match = text.match(/(?:Status:\s*|HTTP\s+)(\d{3})/i);
  if (match) {
    const code = match[1];
    const label = HTTP_STATUS_LABELS[code] || '';
    return label ? `${code} ${label}` : code;
  }
  return text.replace(/https?:\/\/\S+/g, '').replace(/\s*\|\s*/g, ' ').replace(/\s+/g, ' ').trim() || 'Request failed';
}

export function getNoShowOtaState(booking, markResult = null) {
  const ota = markResult?.ota || booking?.no_show_ota || markResult?.channelhub || null;
  const channelName = booking?.channel?.name || booking?.channel_data?.name || '';
  const partner = ota?.partner || resolveNoShowOtaPartner(channelName);
  const partnerLabel = ota?.partner_label || getNoShowOtaPartnerLabel(partner);
  const requiresOta = Boolean(partner);
  const isMarked = String(booking?.status || markResult?.status || '').toLowerCase() === 'no_show'
    || markResult?.marked === true
    || markResult?.no_show_status === 'marked';
  const needsRetry = Boolean(ota?.needs_retry) || (Boolean(ota) && ota.success === false && !isMarked);
  const otaSuccess = Boolean(ota?.success) && !needsRetry;
  return {
    ota,
    partner,
    partnerLabel,
    requiresOta,
    isMarked,
    needsRetry,
    otaSuccess,
    roomsReleased: Boolean(markResult?.rooms_released || ota?.rooms_released),
    message: formatNoShowOtaMessage(ota?.message || markResult?.message || ''),
  };
}
